module.exports = __webpack_public_path__ + "static/img/8-1.debb347.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/8-1.png
// module id = cZdg
// module chunks = 0